import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { CtaBarContentModel } from '@libs/cms/models';
import { PageBlockImpressionDirective, PageBlockLinkClickDirective, provideContentTrackingContext } from '@libs/shared/tracking';
import { ContentLinkDirective } from '@libs/shared/ui';
import { HeadlinesComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-cta-bar',
  templateUrl: './cta-bar.component.html',
  styleUrls: [
    './cta-bar.component.scss',
    './cta-bar.component.lekkerland-2026.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeadlinesComponent,
    ContentLinkDirective,
    MatAnchor,
    PageBlockImpressionDirective,
    PageBlockLinkClickDirective,
  ],
  host: {
    '[class]': 'data().view.background',
  },
  providers: [
    provideContentTrackingContext(CtaBarComponent),
  ],
})
export class CtaBarComponent extends ContentBaseComponent<CtaBarContentModel> {
  public headingLevel: InputSignal<number> = input(2);
}
